import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import { SEO_CONTENT } from '../constants/seoData';
import StructuredData from '../components/StructuredData';

const Faq = () => {
  return (
    <>
      <StructuredData />
      <div className="bg-[#24574E] min-h-screen pt-32 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          {/* Back link */}
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#5BC0AF] font-bold mb-12 hover:gap-3 transition-all group"
          >
            <ArrowLeft size={20} />
            Retour à l'accueil
          </Link>

          <header className="mb-16">
            <p className="text-[#5BC0AF] font-bold text-xs uppercase tracking-[0.3em] mb-4">Support & Aide</p>
            <h1 className="text-5xl md:text-7xl font-black mb-8 leading-tight tracking-tight">
              Foire Aux <br />
              <span className="text-[#5BC0AF] italic text-4xl md:text-6xl">Questions</span>
            </h1>
            <p className="text-xl text-[#F5F3EE]/60 font-medium max-w-2xl">
              Vous avez des questions sur la gestion de votre association avec SuperAsso ? 
              Nous avons les réponses pour vous aider à libérer votre énergie associative.
            </p>
          </header>

          <div className="space-y-8">
            {SEO_CONTENT.faq.map((item, i) => (
              <div 
                key={i} 
                id={`q-${i}`}
                className="p-8 md:p-10 rounded-[2.5rem] border border-white/10 bg-white/[0.03] backdrop-blur-sm hover:border-[#5BC0AF]/30 transition-all duration-500 group"
              >
                <h3 className="text-xl md:text-2xl font-black mb-6 text-[#5BC0AF] flex gap-4">
                  <span className="opacity-20">Q.</span>
                  {item.question}
                </h3>
                <div className="flex gap-4">
                  <span className="text-[#F9D965] font-black opacity-20 text-xl md:text-2xl">R.</span>
                  <p className="text-[#F5F3EE]/70 leading-relaxed font-medium text-lg">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-24 p-12 rounded-[3rem] bg-[#5BC0AF]/10 border border-[#5BC0AF]/20 text-center">
            <div className="w-16 h-16 bg-[#5BC0AF] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-[#5BC0AF]/20">
              <MessageCircle size={32} className="text-[#24574E]" />
            </div>
            <h2 className="text-3xl font-black mb-4">Encore une question ?</h2>
            <p className="text-[#F5F3EE]/60 font-medium mb-8 max-w-md mx-auto">
              Notre équipe est là pour vous accompagner dans votre quotidien associatif. 
              N'hésitez pas à nous contacter directement.
            </p>
            <Link 
              to="/contact" 
              className="btn-settle inline-block"
            >
              Contactez-nous
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
